import { initializeApp } from "firebase/app";
import { getFirestore, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyC_vmoPtx9QQqhHUBzZt3BnGypwzLUvJ1c",
  authDomain: "rc-adease.firebaseapp.com",
  projectId: "rc-adease",
  storageBucket: "rc-adease.appspot.com",
  messagingSenderId: "897518676581",
  appId: "1:897518676581:web:e2a5b65cc0b00bf533b48c"
};

initializeApp(firebaseConfig)

const db = getFirestore()
const auth = getAuth()

export {db, auth, Timestamp}